<template>
  <div class="service" v-show="this.$route.path.includes('covid')">
    <p>Have questions?</p>
    <p>
      <el-tooltip
        class="item"
        effect="dark"
        content="covid19@ailifeus.com"
        placement="top-start"
      >
        <a href="mailto:covid19@ailifeus.com" title="Email ">
          <i class="iconfont">&#xe651;</i>
        </a>
      </el-tooltip>
    </p>
    <p>
      <el-tooltip
        class="item"
        effect="dark"
        content="Consult with us through Alliance Genomics"
        placement="top-start"
      >
        <a
          href="https://www.ailifeus.net/#/consult?covid-19=true"
          target="_blank"
        >
          <i class="iconfont">&#xe60a;</i>
        </a>
      </el-tooltip>

      <!-- <a href="https://www.ailifeus.net/#/" target="_blank">
        consult us through Alliance Genomics</a
      > -->
    </p>
  </div>
</template>

<script>
export default {
  name: "service",
  created() {},
  watch: {},
  data() {
    return {
      searchValue: "",
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.service {
  width: 80px;
  min-height: 50px;
  position: fixed;
  right: 0;
  top: 60%;
  transform: translate(-50%, 0);
  z-index: 1000;
  border: 1px solid $color_default;
  p {
    text-align: center;
    font-size: 14px;
    a {
      color: $color_default;
      display: inline-block;

      i {
        font-size: 30px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/service/index.vue